import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Route, Router } from '@angular/router';
import { Observable, of, tap } from 'rxjs';
import { Beneficiary } from 'src/app/model/beneficiary.model';
import { Countries } from 'src/app/model/countries';
import { Days } from 'src/app/model/days';
import { Mounths } from 'src/app/model/mounths';
import { UpdatedBeneficiary } from 'src/app/model/updateBeneficiary.model';
import { Years } from 'src/app/model/years';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { BackendApiService } from 'src/app/service/backend-api.service';

interface Day {
  id: number;
}
@Component({
  selector: 'app-form-profil',
  templateUrl: './form-profil.component.html',
  styleUrls: ['./form-profil.component.css'],
})
export class FormProfilComponent implements OnInit {
  beneficiaryForm!: FormGroup;
  countries!: Countries[];
  cities!: any[];
  phoneCode!: any[];
  days!: Day[];
  mounths: any[] = [];
  years!: any[];
  isSenegalSelected!: boolean;
  users: any;
  gender!: any[];
  myDayOfBirth: string = '';
  myMonthOfBirth: string = '';
  myYearOfBirth: string = '';

  beneficiary$!: Observable<Beneficiary[]>;
  beneficiary!: Beneficiary;
  succes = false;
  error = false;
  constructor(
    private backendapiService: AuthService,
    private formBuilder: FormBuilder,
    private route: Router,
  ) {
    this.beneficiaryForm = this.formBuilder.group({
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      sexe: [{ value: '', disabled: true }],
      selectedDay: [''],
      selectedMounth: [''],
      selectedYear: [''],
      selectedCountry: [''],
      selectedNationality: [''],
      selectedCity: [{ value: '', disabled: true }],
      phoneCodeOne: ['221'],
      phoneCodeTwo: ['221'],
      phoneCodeWave: ['221'],
      phoneNumberOne: [''],
      phoneNumberTwo: [''],
      phoneNumberWave: [''],
      email: [{ value: '', disabled: true }],
    });

    this.users = sessionStorage.getItem('user');
    // console.log('user test', JSON.parse(this.users));
    // console.log('La date de naissance: ', JSON.parse(this.users)?.dateBirth);

    const dateString = JSON.parse(this.users)?.dateBirth?.toString();
    // console.log('La date de naissance: ', dateString);
    if (dateString != null) {
      // console.log('La date de naissance dans le control: ', dateString);
      this.initDateBirth(dateString);
    }
  }

  getSexeLabel(value: number): string {
    return value === 1 ? 'Masculin' : 'Féminin';
  }

  ngOnInit(): void {
    this.days = Days.List;
    this.years = Years.List;
    this.mounths = Mounths.List;
    // console.log(this.mounths[0].name);

    this.backendapiService.getCountries().subscribe((data) => {
      this.countries = data.sort((c, d) => (c.name < d.name ? -1 : 1));
    });
    this.backendapiService.getCountries().subscribe((data) => {
      this.phoneCode = data.sort((c, d) =>
        c.phoneCode < d.phoneCode ? -1 : 1,
      );
    });

    this.backendapiService.getCities().subscribe((data) => {
      this.cities = data;
    });

    if (JSON.parse(this.users)?.country?.id == 287) {
      this.isSenegalSelected = true;
    }

    this.beneficiaryForm.patchValue({
      firstname: JSON.parse(this.users)?.firstname,
      lastname: JSON.parse(this.users)?.lastname,
      sexe: JSON.parse(this.users)?.gender.id,
      phoneNumberOne: JSON.parse(this.users)?.phoneNumberOne,
      phoneNumberTwo: JSON.parse(this.users)?.phoneNumberTwo,
      phoneNumberWave: JSON.parse(this.users)?.waveNumber,
      email: JSON.parse(this.users)?.email,
      selectedCity: JSON.parse(this.users)?.city?.id,
      selectedCountry: JSON.parse(this.users)?.country?.id,
      selectedNationality: JSON.parse(this.users)?.nationalite,
    });

    this.beneficiaryForm
      .get('selectedCountry')
      ?.valueChanges.subscribe((selectedCountryId: number) => {
        if (selectedCountryId == 287) {
          this.isSenegalSelected = true;
        } else {
          this.isSenegalSelected = false;
        }
      });
  }

  onSubmitForm() {
    const formValue = this.beneficiaryForm.value;
    // console.log('formValue:', formValue);

    const day = formValue['selectedDay'];
    const mounth = formValue['selectedMounth'];
    const year = formValue['selectedYear'];

    const updatedBeneficiary = new UpdatedBeneficiary(
      formValue['firstname'],
      formValue['lastname'],
      new Date(year, mounth, day),
      formValue['selectedCity'] == null ||
        formValue['selectedCity'] == undefined
        ? 1
        : formValue['selectedCity'],
      formValue['selectedCountry'],
      formValue['selectedNationality'],
      formValue['email'],
      formValue['phoneNumberOne'],
      formValue['phoneNumberTwo'],
      formValue['phoneNumberWave'],
    );
    // console.log('for submit:', updatedBeneficiary);

    this.backendapiService
      .updateBeneficiary(JSON.parse(this.users).iuf, updatedBeneficiary)
      .subscribe((Response) => {
        // console.log('la reponse: ', Response);
        if (Response.status == 200) {
          this.succes = true;
          setTimeout(() => {
            this.succes = false;
            this.route.navigate(['dashboard/users/profil']);
            // window.location.reload();
          }, 3000);
        } else {
          this.error = true;
          setTimeout(() => {
            this.error = false;
          }, 3000);
        }

        // window.location.reload();
      });
  }

  initDateBirth(dateBirth: any) {
    if (dateBirth != null) {
      const splitted = dateBirth.split('-', 3);
      this.myYearOfBirth = splitted[0];
      this.myMonthOfBirth = splitted[1];
      this.myDayOfBirth = splitted[2];

      this.beneficiaryForm.controls['selectedDay'].setValue(
        Days.findByCode(this.myDayOfBirth)?.id,
      );
      this.beneficiaryForm.controls['selectedMounth'].setValue(
        Mounths.findByCode(this.myMonthOfBirth)?.id,
      );
      // console.log(this.beneficiaryForm.value);
      this.beneficiaryForm.controls['selectedYear'].setValue(
        this.myYearOfBirth,
      );
    } else {
      this.myYearOfBirth = '';
      this.myMonthOfBirth = '';
      this.myDayOfBirth = '';

      this.beneficiaryForm.controls['selectedDay'].setValue(this.myDayOfBirth);
      this.beneficiaryForm.controls['selectedMounth'].setValue(
        this.myMonthOfBirth,
      );
      this.beneficiaryForm.controls['selectedYear'].setValue(
        this.myYearOfBirth,
      );
    }
  }
}
